// Action Types
export const FETCH_BUSINESS_UNIT_ACC_DETAILS_REQUEST =
  "FETCH_BUSINESS_UNIT_ACC_DETAILS_REQUEST";
export const FETCH_BUSINESS_UNIT_ACC_DETAILS_SUCCESS =
  "FETCH_BUSINESS_UNIT_ACC_DETAILS_SUCCESS";
export const FETCH_BUSINESS_UNIT_ACC_DETAILS_FAILURE =
  "FETCH_BUSINESS_UNIT_ACC_DETAILS_FAILURE";
export const FETCH_BUSINESS_UNIT_ACC_DETAILS_RESET = 
  "FETCH_BUSINESS_UNIT_ACC_DETAILS_RESET"
// Action Creators
export const fetchBusinessUnitAccDetailRequest = (payload) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_BUSINESS_UNIT_ACC_DETAILS_REQUEST,
      payload,
    });
  };
};
export const fetchBusinessUnitAccDetailSuccess = (data) => ({
  type: FETCH_BUSINESS_UNIT_ACC_DETAILS_SUCCESS,
  payload: data,
});
export const fetchBusinessUnitAccDetailFailure = (error) => ({
  type: FETCH_BUSINESS_UNIT_ACC_DETAILS_FAILURE,
  payload: error,
});
export const fetchBusinessUnitAccDetailReset = (error) => ({
  type: FETCH_BUSINESS_UNIT_ACC_DETAILS_RESET,
  payload: error,
});


